__turbopack_context__.v({
  "hero": "_91pHOG_hero",
  "heroArticle": "_91pHOG_heroArticle",
  "heroText": "_91pHOG_heroText",
  "heroTitle": "_91pHOG_heroTitle",
  "tab": "_91pHOG_tab",
  "tabsList": "_91pHOG_tabsList",
});
